import {z} from "zod";

export const UPLOAD_FILE_ENUM = ["CUSTOMER_MANAGEMENT", "VISIT_HISTORY", "TAX_ACCOUNTANT_STATUS"] as const;
export const UPLOAD_FILE_TYPE = z.enum(UPLOAD_FILE_ENUM);
export type UPLOAD_FILE_TYPE = z.infer<typeof UPLOAD_FILE_TYPE>;

const schema = z.object({
	fileName: z.string(),
	fileType: UPLOAD_FILE_TYPE
});

const model = schema.transform((values) => ({
	...values
}));

export const GeneratePresignedUrlModel = {schema, model};
export type IGeneratePresignedUrlModel = z.infer<typeof GeneratePresignedUrlModel.model>;
export const DEFAULT_GENERATE_PRESIGNED_URL: IGeneratePresignedUrlModel = {
	fileName: "",
	fileType: "VISIT_HISTORY"
};
